import SelectInput from './SelectInput';
import PasswordInput from './PasswordInput';

const labelExculdes = ['checkbox', 'radio'];

function FormInput({
  id,
  label = null,
  error = null,
  placeholder = '',
  formFieldType,
  isRequired,
  register,
  isDisabled = false,
  ...attrs
}) {
  const formFieldClassName = formFieldType === 'text' ? 'input' : formFieldType;
  return (
    <div className={`blaze-user-form__input-group__input ${formFieldClassName} ${id}`}>
      <div className={`form-field form-field--${formFieldClassName}`}>
        {!!label && !labelExculdes.includes(formFieldType) && (
          <label className="required">
            <span>{label}</span>
          </label>
        )}

        {renderInput({
          id,
          label,
          placeholder,
          formFieldType,
          isRequired,
          register,
          error,
          isDisabled,
          ...attrs
        })}
        {error && (
          <div className="validation">
            <i className="material-icons">warning</i>
            <span>{error.message}</span>
          </div>
        )}
      </div>
    </div>
  );
}

const renderInput = ({ ...props }) => {
  const {
    formFieldType: type,
    label,
    value,
    id,
    register,
    options,
    error,
    disabled,
    isRequired,
    placeholder,
    isDisabled
  } = props;
  const inputClassName = error ? 'error-field' : '';

  switch (type) {
    case 'select':
      return (
        <SelectInput
          id={id}
          label={label}
          selected={value}
          register={register}
          options={options}
          disabled={disabled}
          selectDisabled={isDisabled}
          showDefaultOption={false}
          required={isRequired}
          value={value}
          placeholder={placeholder}
          classNames={inputClassName}
        />
      );

    case 'checkbox':
      return (
        <div className="checkbox-input">
          <div className="checkbox-wrapper">
            <div className="form-field form-field--checkbox" role="button">
              <input
                type="checkbox"
                id={id}
                {...register(id)}
                className="form-checkbox"
                disabled={isDisabled}
              />
              <label>
                <span>{label}</span>
              </label>
            </div>
          </div>
        </div>
      );

    case 'radio':
      return (
        <div className="form-field form-field--radio" disabled={isDisabled}>
          <input
            id={id}
            type="radio"
            {...register(id)}
            disabled={isDisabled}
            className={inputClassName}
          />
          <span>{label}</span>
        </div>
      );
    case 'password':
      return (
        <PasswordInput
          id={id}
          placeholder={placeholder}
          className={inputClassName}
          register={register}
        />
      );
    default:
      return (
        <input
          id={id}
          type={type ?? 'text'}
          placeholder={placeholder}
          {...register(id)}
          disabled={isDisabled}
          className={inputClassName}
        />
      );
  }
};

export default FormInput;
